import ToggleButtonGroup, {
  ToggleOption,
} from '../../../../components/Forms/Buttons/ToggleButtonGroup';
import SearchInputField from '../../../../components/Forms/Input/SearchInputField';
import SelectField from '../../../../components/Forms/Input/SelectField';
import { MenuActiveFilter, MenuAvailabilityFilter, MenuCategoryOption, MenuFeaturedFilter } from '../types';



interface MenuFiltersProps {
  search: string;
  categoryId: number;
  activeFilter: MenuActiveFilter;
  availabilityFilter: MenuAvailabilityFilter;
  featuredFilter: MenuFeaturedFilter;
  categories: MenuCategoryOption[];
  onSearchChange: (value: string) => void;
  onCategoryChange: (categoryId: number) => void;
  onActiveChange: (value: MenuActiveFilter) => void;
  onAvailabilityChange: (
    value: MenuAvailabilityFilter
  ) => void;
  onFeaturedChange: (
    value: MenuFeaturedFilter
  ) => void;
}

const activeOptions = [
  {
    value: 'ALL',
    label: 'Todos',
  },
  {
    value: 'ACTIVE',
    label: 'Activos',
  },
  {
    value: 'INACTIVE',
    label: 'Inactivos',
  },
] satisfies ToggleOption<MenuActiveFilter>[];

const MenuFilters = ({
  search,
  categoryId,
  activeFilter,
  availabilityFilter,
  featuredFilter,
  categories,
  onSearchChange,
  onCategoryChange,
  onActiveChange,
  onAvailabilityChange,
  onFeaturedChange,
}: MenuFiltersProps) => {
  return (
    <div className="grid grid-cols-1 gap-4 border-b border-stroke p-5 dark:border-strokedark sm:px-7 md:grid-cols-2 xl:grid-cols-[minmax(260px,1.2fr)_240px_210px_210px_auto] xl:items-end">
      <div className="md:pb-5">
        <SearchInputField
          label="Buscar"
          name="menuSearch"
          value={search}
          iconKey="search"
          placeholder="Buscar platillo, bebida o código..."
          withMargin={false}
          onChange={(event) =>
            onSearchChange(event.target.value)
          }
        />
      </div>

      <SelectField
        label="Categoría"
        name="menuCategoryFilter"
        value={categoryId}
        iconKey="categories"
        options={[
          {
            value: 0,
            label: 'Todas las categorías',
          },
          ...categories.map((category) => ({
            value: category.id,
            label: category.name,
          })),
        ]}
        onChange={(event) =>
          onCategoryChange(Number(event.target.value))
        }
      />

      <SelectField
        label="Disponibilidad"
        name="menuAvailabilityFilter"
        value={availabilityFilter}
        iconKey="status"
        options={[
          {
            value: 'ALL',
            label: 'Todos',
          },
          {
            value: 'AVAILABLE',
            label: 'Disponibles',
          },
          {
            value: 'UNAVAILABLE',
            label: 'No disponibles',
          },
        ]}
        onChange={(event) =>
          onAvailabilityChange(
            event.target.value as MenuAvailabilityFilter
          )
        }
      />

      <SelectField
        label="Destacado"
        name="menuFeaturedFilter"
        value={featuredFilter}
        iconKey="status"
        options={[
          {
            value: 'ALL',
            label: 'Todos',
          },
          {
            value: 'FEATURED',
            label: 'Destacados',
          },
          {
            value: 'NOT_FEATURED',
            label: 'No destacados',
          },
        ]}
        onChange={(event) =>
          onFeaturedChange(
            event.target.value as MenuFeaturedFilter
          )
        }
      />

      <ToggleButtonGroup
        value={activeFilter}
        options={activeOptions}
        onChange={onActiveChange}
        className="mb-5"
      />
    </div>
  );
};

export default MenuFilters;